<template>
  <div class="form-group d-flex align-items-center">
    <input
      v-bind="$attrs"
      @change="createBase64($event)"
      v-bind:value="value"
      type="file"
      class=""
      :id="name"
    />
  </div>
</template>

<script>
export default {
  name: "ImageComponent",
  props: {
    label: String,
    name: String,
    imageName: String,
    value: [String, Boolean, Array, Object, Number, File, HTMLInputElement],
  },
  methods: {
    async createBase64(e) {
     
      this.$emit("input", e.target.files);
    },
  },
};

// formRequest.files = await Promise.all(
//   Object.values(files)
//     .filter((i) => !!i)
//     .map(async (img) => {
//       return new Promise((resolve, reject) => {
//         const reader = new FileReader();
//         reader.onloadend = () => {
//           resolve(reader.result);
//         };
//         reader.readAsDataURL(img[0]);
//       });
//     })
// );
</script>

<style>
</style>